import { useState } from "react";

import AiActionComposer from "../ai/actions/AiActionComposer";
import AiPanel from "../disbursement/ai/AiPanel";

const ExtraValuesAiPanel = ({ workId, onClose, onExecuted }) => {
  const [possibility, setPossibility] = useState(null);
  return (
    <AiPanel title="Criar estouro ou economia com IA" onClose={onClose}>
      {!possibility ? (
        <div className="grid gap-8">
          <p>
            Escolha o que deseja planejar. Você revisará a proposta antes da
            confirmação.
          </p>
          <button
            type="button"
            className="button button-outline"
            onClick={() => setPossibility("expense")}
          >
            Planejar estouro
          </button>
          <button
            type="button"
            className="button button-outline"
            onClick={() => setPossibility("saving")}
          >
            Planejar economia
          </button>
        </div>
      ) : (
        <>
          <button
            type="button"
            className="button button-secondary small"
            onClick={() => setPossibility(null)}
          >
            Trocar possibilidade
          </button>
          <AiActionComposer
            workId={workId}
            module="extra_value"
            onExecuted={onExecuted}
          />
        </>
      )}
    </AiPanel>
  );
};

export default ExtraValuesAiPanel;
